import { SubpageLayout2018 } from './subpageLayout';

export default function JudgesCriteria2018() {
  return (
    <SubpageLayout2018 lang="en" title="Judging Criteria" page="judges_criteria">
      <div className="para_introduction">
        <h1>Judges Criteria</h1>
        <div className="center_introduction">
          <p className="p1">Assessment is judging based on the following main factors:</p>
        </div>
        <div className="criteria_container">
          <div className="criteria_1 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.3s" data-offset="100">
            <div className="crit_text">Benefits and<br /> Impact<br /><br />[20%]</div>
          </div>
          <div className="criteria_2 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.4s" data-offset="100">
            <div className="crit_text crit_text2">Functionality<br /><br />[20%]</div>
          </div>
          <div className="criteria_3 criteria_1 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.5s" data-offset="100">
            <div className="crit_text">Market Potential /<br /> Performance<br /><br />[20%]</div>
          </div>
          <div className="criteria_4 criteria_2 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.6s" data-offset="100">
            <div className="crit_text crit_text2">Quality<br /><br />[20%]</div>
          </div>
          <div className="criteria_5 criteria_1 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.7s" data-offset="100">
            <div className="crit_text">Innovation and<br /> Creativity<br /><br />[20%]</div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

